
import GenerateImageHelper from '@/Scripts/lib/helper/generateImageHelper.js';
function getFocalPoint (mediaObj, proportion) {
  if (proportion && mediaObj.Center && mediaObj.Center.length > 0) {
    const closestCenter = mediaObj.Center.reduce((a, b) => {
      // const realAspecRatioA = (a.BottomRightX - a.TopLeftX) / (a.BottomRightY - a.TopLeftY);
      // const realAspecRatioB = (b.BottomRightX - b.TopLeftX) / (b.BottomRightY - b.TopLeftY);
      // return Math.abs(realAspecRatioB - proportion) < Math.abs(realAspecRatioA - proportion) ? b : a;
      return Math.abs(b.AspectRatio - proportion) < Math.abs(a.AspectRatio - proportion) ? b : a;
    });
    if (closestCenter) {
      const imageRatio = mediaObj.Width / mediaObj.Height;
      // downscale backdrop and image before transforming because it will fail in cloudinary if too large
      if (mediaObj.BackDrop) {
        if (imageRatio >= 1) {
          // if (mediaObj.Width > 5000) {
          mediaObj.Width = 5000;
          mediaObj.Height = Math.round(5000 / imageRatio);
          // }
        } else {
          // if (mediaObj.Height > 5000) {
          mediaObj.Height = 5000;
          mediaObj.Width = Math.round(5000 * imageRatio);
          // }
        }
      }
      const x1 = closestCenter.TopLeftX * mediaObj.Width;
      const x2 = closestCenter.BottomRightX * mediaObj.Width;
      const w = x2 - x1;
      const y1 = closestCenter.TopLeftY * mediaObj.Height;
      const y2 = closestCenter.BottomRightY * mediaObj.Height;
      const h = y2 - y1;
      const focal = {
        usedCenter: closestCenter,
        aspectRatio: closestCenter.AspectRatio,
        x: Math.round(x1 + (w * 0.5)),
        y: Math.round(y1 + (h * 0.5))
      };
      if (proportion >= imageRatio) {
        focal.w = Math.round(w);
        focal.h = Math.round(w / proportion);
      } else {
        // vertical
        focal.w = Math.round(h * proportion);
        focal.h = Math.round(h);
      }
      return focal;
    }
  }
  console.warn('No focal point found for media object', mediaObj);
  return null;
};
export default {
  getFocalPoint,
  buildMediaObject (mediaObj, proportion, sizes, bgcolor = null, includeNoFocal = false, forceDim = null) {
    const type = mediaObj.Id && mediaObj.Id.includes('.mp4') ? 'VideoFile' : 'ImageMediaData';
    if (type === 'ImageMediaData') {
      const focal = getFocalPoint(mediaObj, proportion);
      // 764 = default size if srcset for some reason is omitted by the browser
      let src = GenerateImageHelper.generateFocal(mediaObj.PathCdn, { width: 764, height: 764 / proportion, bgcolor: bgcolor, focal, backDrop: mediaObj.BackDrop });
      if (forceDim !== null && forceDim.width && forceDim.height) {
        src = GenerateImageHelper.generateFocal(mediaObj.PathCdn, { width: forceDim.width, height: forceDim.height, bgcolor: bgcolor, focal });
      }
      // const outputName = mediaObj.Name ? mediaObj.Name.replace('.jpg', '').replace('-', ' ') : '';
      const obj = {
        id: mediaObj.PathCdn,
        src: src,
        srcset: GenerateImageHelper.generateSrcset(mediaObj.PathCdn, focal, bgcolor, null, null, mediaObj.BackDrop),
        sizes: sizes,
        title: mediaObj.Title,
        description: mediaObj.AltText,
        text: mediaObj.Text,
        Link: mediaObj.Link,
        products: mediaObj.Products ? mediaObj.Products.filter(p => p.Model) : null,
        type: 'ImageMediaData',
        ratio: mediaObj.Width / mediaObj.Height,
        pbval: `${Math.floor((mediaObj.Height / mediaObj.Width) * 100)}%`,
        backDrop: mediaObj.BackDrop,
        styling: mediaObj.styling
      };
      if (includeNoFocal) {
        obj.noFocal = {
          src: GenerateImageHelper.generateFocal(mediaObj.PathCdn, { width: mediaObj.Width, height: mediaObj.Height, bgcolor: bgcolor }),
          srcset: GenerateImageHelper.generateSrcset(mediaObj.PathCdn, null, bgcolor)
        };
      }
      return obj;
    } else if (type === 'VideoFile') {
      return {
        id: mediaObj.PathCdn,
        src: GenerateImageHelper.generateVideo(mediaObj.PathCdn),
        title: mediaObj.Title,
        description: mediaObj.AltText,
        text: mediaObj.Text,
        Link: mediaObj.Link,
        products: mediaObj.Products,
        type: 'VideoFile',
        ratio: mediaObj.Width / mediaObj.Height,
        width: mediaObj.Width,
        height: mediaObj.Height,
        pbval: `${Math.floor((mediaObj.Height / mediaObj.Width) * 100)}%`,
        styling: mediaObj.styling
      };
    }
    return {};
  }

};
